import { Component, Input } from '@angular/core';
import { UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaginationCommonDirective } from './pagination-common.directive';
import { PaginationData } from './pagination.data';
import { NgxPaginationModule } from 'ngx-pagination';

export interface PaginationMethods {
    goToPage(pageNum: number): void;
}

/**
 * To use the pagination component you need:
 * - To implement the PaginationMethods interface on the component that uses it.
 * - Have a *ng-for loop on the component that uses pagination that includes a pagination call like:
 * 			<tr *ngFor="let claim of claims | paginate: {
 * 					itemsPerPage: paginationData.size,
 * 					currentPage: paginationData.number + 1,
 * 					totalItems: paginationData.totalElements }">
 * 	See documentation of ngx-pagination for details
 */
@Component({
    selector: 'novi-pagination',
    templateUrl: 'pagination.component.html',
    standalone: true,
    imports: [
        NgxPaginationModule,
        FormsModule,
        ReactiveFormsModule,
    ],
})
export class PaginationComponent extends PaginationCommonDirective {
    @Input() pageData: PaginationData<any>;
    @Input() callingComponent: PaginationMethods;

    constructor(private formBuilder: UntypedFormBuilder) {
        super();
        this.paginationForm = this.formBuilder.group({
            pageNumber: '',
        });
    }

    changePage(pageNumber) {
        this.callingComponent.goToPage(pageNumber);
    }
}
